import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography
} from '@mui/material';

interface SizeModalProps {
  visible: boolean;
  onDismiss: () => void;
  onAccept: (offset: string) => void;
  size: string;
}

const SizeModal: React.FC<SizeModalProps> = ({
  visible,
  onDismiss,
  onAccept,
  size
}) => {
  const [sizeFeet, setSizeFeet] = useState(0);
  const [sizeInches, setSizeInches] = useState(0);

  const parseFeetAndInches = (value: string) => {
    const [feetStr, inchesStr] = value.split("'");
    const feet = parseInt(feetStr, 10) || 0;
    const inches = parseInt(inchesStr, 10) || 0;
    return { feet, inches };
  };

  useEffect(() => {
    if (visible && size) {
      const { feet, inches } = parseFeetAndInches(size);
      setSizeFeet(feet);
      setSizeInches(inches);
    }
  }, [visible, size]);

  const handleChangeFeet = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSizeFeet(parseInt(event.target.value, 10) || 0);
  };

  const handleChangeInches = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSizeInches(parseInt(event.target.value, 10) || 0);
  };

  const handleAccept = () => {
    const totalSize = sizeFeet * 12 + sizeInches;
    onAccept(totalSize.toString());
    onDismiss();
  };

  return (
    <Dialog open={visible} onClose={onDismiss}>
      <DialogTitle>Set Size</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Typography variant="subtitle1">Feet</Typography>
            <TextField
              type="number"
              value={sizeFeet}
              onChange={handleChangeFeet}
              fullWidth
              inputProps={{ min: 0, max: 500 }}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">Inches</Typography>
            <TextField
              type="number"
              value={sizeInches}
              onChange={handleChangeInches}
              fullWidth
              inputProps={{ min: 0, max: 9, step: 3 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDismiss} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleAccept} color="primary">
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SizeModal;
